import React from 'react';
interface MasonryGridProps {
  children: ReactNode;
}
export function MasonryGrid({
  children
}: MasonryGridProps) {
  return <div className="columns-2 md:columns-3 lg:columns-4 xl:columns-5 gap-4 px-2 md:px-4 mx-auto max-w-[2000px] w-full pb-20" data-id="element-97">
      {children}
    </div>;
}